import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { unauthenticated } from '@datev/ngx-dcal';
import { environment } from 'projects/environments/environment';
import { Observable } from 'rxjs';
import { Download } from '../../model';

@Injectable({ providedIn: 'root' })
export class PdfRetrievalService {
  private baseUrl = environment.downloadDetailsDocViewerBaseUrl;

  constructor(private readonly httpClient: HttpClient) {}

  getPdfData(downloadDetails: Download['details']): Observable<ArrayBuffer> {
    return this.httpClient.get(
      `${this.baseUrl}${downloadDetails}`,
      {
        context: unauthenticated(),
        responseType: 'arraybuffer',
      },
    );
  }
}
